<template lang="pug">
v-layout(row wrap)
  v-flex.pa-1(xs12 md8 offset-md2 lg6 offset-lg3)
    v-subheader.pr-0
      | {{ value.title }}
  v-flex.pa-0(xs12 md8 offset-md2 lg6 offset-lg3)
    .pr-3.text-xs-right.grey--text.text--lighten--1
      v-icon.subheading.pr-1(v-text="$vuetify.icons.endAt")
      | {{ endAt }}
  v-flex(v-for="e in value.pairings_themes_users" :key="e.id" xs12 md8 offset-md2 lg6 offset-lg3)
    pairings-themes-user-row(
      :value="e"
      @on-answer="onAnswer"
      @on-result="onResult")
</template>

<script>
'use strict'
import Pairing from '@/models/pairing'
import BtnIcon from '@/components/button/BtnIcon'
import PairingsThemesUserRow from '@/components/card/PairingsThemesUserRow'
import TimeSupport from '@/utils/time-support'

export default {
  components: {
    BtnIcon,
    PairingsThemesUserRow
  },
  props: {
    value: {
      type: Pairing,
      required: true,
    }
  },
  computed: {
    endAt () {
      return this.value.end_at.humanWithSuffix(this.$t('text.endAtSuffix'))
    }
  },
  methods: {
    onAnswer (pairingsThemesUser) {
      this.$emit('on-answer', pairingsThemesUser)
    },
    onResult (pairingsThemesUser) {
      this.$emit('on-result', pairingsThemesUser)
    },
    onPairingResult () {
      this.$emit('on-pairing-result', this.value)
    }
  }
}
</script>
